<!-- 滿意度表格分析，畫面渲染元件 -->
<template>
  <div class="satisfaction-analysis-table-container">
    <div>
      <el-alert
        style="background-color: #ffd643; color: #4b4b4b; margin-bottom: 10px"
        :closable="false"
        type="info"
        effect="dark"
      >
        <template slot="title">
          1、滿意度定義 ：對旅遊的整體滿意度調查「滿意」之定義－採5分量表問卷，以達4分為滿意<br />
          2、滿意度計算公式
          ：(非常不滿意次數*1分+不太滿意*2分+普通*3分+滿意*4分+非常滿意*5分)/總次數<br />
          3、資料來源：智遊旅程-團體旅遊app
        </template>
      </el-alert>

      <el-descriptions
        :labelStyle="{ 'text-align': 'left', 'font-size': '12px' }"
        :contentStyle="{ 'text-align': 'center' }"
        v-if="currentSatisfactionAnalysis"
        class="margin-top"
        title=""
        :column="4"
        :size="'medium'"
        border
        style="margin: 5px; border: 2px solid #ccc"
      >
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            填寫數量
          </template>
          <el-tag size="small">
            {{ currentSatisfactionAnalysis.userReplyCount }}/{{
              currentSatisfactionAnalysis.userCount
            }}</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            整體滿意度
          </template>
          <el-tag
            size="small"
            :type="
              getSatisfactionAnalysisStyle(
                currentSatisfactionAnalysis.totalSatisfactionPoint,
                currentSatisfactionAnalysis.kind
              )
            "
          >
            {{ currentSatisfactionAnalysis.totalSatisfactionPoint }}</el-tag
          >
        </el-descriptions-item>

        <!-- <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-tickets"></i>
            滿意度說明
          </template>
          <div style="padding: 8px">
            <el-alert
              title="需要注意的事项"
              type="info"
              effect="dark"
              :closable="false"
              style="text-align: left"
            >
              <template
                slot="title"
                v-if="currentSatisfactionAnalysis.kind == 1"
              >
                <div style="color: yellow; font-size: 15px">
                  {{ `${currentSatisfactionAnalysis.title} 滿意度表格分析` }}:
                </div>
                <div>
                  1、滿意度定義 ：
                  <span
                    >對旅遊的整體滿意度調查「滿意」之定義－採5分量表問卷，以達4分為滿意。</span
                  ><br />
                </div>
                <div>
                  2、滿意度計算公式 ：
                  <span
                    >(非常不滿意次數*1分+不太滿意*2分+普通*3分+滿意*4分+非常滿意*5分)/總次數。</span
                  >
                </div>
                <div>3、資料來源：智遊旅程-團體旅遊app。</div>
              </template>
              <template
                slot="title"
                v-if="currentSatisfactionAnalysis.kind == 2"
              >
                <div style="color: yellow; font-size: 15px">
                  {{ `${currentSatisfactionAnalysis.title} 滿意度表格分析` }}:
                </div>
                <div>
                  1、滿意度定義 ：
                  <span
                    >對旅遊的整體滿意度調查「好」之定義－採5分量表問卷，以達3分為滿意。</span
                  >
                </div>
                <div>
                  2、滿意度計算公式 ：
                  <span>(不好*1分+普通*2分+好*3分)/總次數。</span>
                </div>
                <div>3、資料來源：智遊旅程-團體旅遊app。</div>
              </template>
            </el-alert>
          </div>
        </el-descriptions-item> -->
      </el-descriptions>
    </div>

    <div style="padding: 10px">
      <el-table
        :cell-style="cellStyleSet"
        v-if="currentSatisfactionAnalysis && currentSatisfactionAnalysis.topicList.length > 0"
        size="mini"
        :data="currentSatisfactionAnalysis.topicList"
        border
        style="width: 100%"
        height="100%"
        :header-cell-style="{ textAlign: 'center' }"
      >
        <el-table-column align="left" label="題    目" width="230">
          <template slot-scope="scope">
            <span>{{ scope.row.topicDescription }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          width="200"
          v-for="item in currentSatisfactionAnalysis.options"
          :key="item.optionID"
          :label="item.optionDescription"
        >
          <el-table-column
            align="center"
            label="次數"
            width="120"
            :prop="
              JSON.stringify({
                property: 'count',
                key: item.optionDescription,
              })
            "
            :formatter="cellFormatter"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="百分比"
            width="120"
            :prop="
              JSON.stringify({
                property: 'percentage',
                key: item.optionDescription,
              })
            "
            :formatter="cellFormatter"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="滿意度">
          <template></template>
          <template slot-scope="scope">
            <el-tag
              class="colorbase"
              style="font-size: 18px"
              size="medium"
              :type="
                getSatisfactionAnalysisStyle(
                  scope.row.satisfactionAnalysis,
                  currentSatisfactionAnalysis.kind
                )
              "
              >{{ scope.row.satisfactionAnalysis }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SatisfactionAnalysisTable',
  components: {},
  props: {
    currentSatisfactionAnalysis: {
      type: Object,
      default: null,
    },
  },
  watch: {},
  data() {
    return {}
  },
  async created() {},
  methods: {
    getSatisfactionAnalysisStyle(v, kind) {
      let tryParseInt = parseInt(v)
      let style = ''
      if (kind == 1) {
        //旅客
        switch (true) {
          case tryParseInt <= 3:
            style = 'danger'
            break
          case tryParseInt <= 4:
            style = 'warning'
            break
          default:
            style = 'success'
            break
        }
      } else if (kind == 2) {
        //領隊
        switch (true) {
          case tryParseInt <= 1:
            style = 'danger'
            break
          case tryParseInt <= 2:
            style = 'warning'
            break
          default:
            style = 'success'
            break
        }
      }

      return style
    },
    cellStyleSet({ row, column, rowIndex, columnIndex }) {
      let style = null
      style = {
        'background-color': 'beige',
      }
      return style
    },
    cellFormatter(row, col) {
      const key = JSON.parse(col.property)
      const d = row.options.find(r => r.optionDescription === key.key)
      if (d && d[key.property]) {
        let tryParseInt = parseInt(d[key.property])
        let colorClass = ''
        if (typeof tryParseInt === 'number') {
          if (key.property == 'count') {
          } else if (key.property == 'percentage') {
            colorClass = 'colorbase'
            // switch (true) {
            //   case tryParseInt < 60:
            //     colorClass = "red-color";
            //     break;
            //   case tryParseInt < 80:
            //     colorClass = "orange-color";
            //     break;
            //   default:
            //     colorClass = "green-color";
            //     break;
            // }
          }
        }
        return (
          <span style="font-weight: bold;" class={colorClass}>
            {d[key.property]}
          </span>
        )
        // return d[key.property];
      }
      return <span class={'gray-color'}>0</span>
    },
  },
}
</script>

<style lang="scss">
Ｆ .colorbase {
  font-weight: bold;
  font-size: 14px;
}

.red-color {
  @extend .colorbase;
  color: red;
}

.orange-color {
  @extend .colorbase;
  color: orange;
}

.green-color {
  @extend .colorbase;
  color: green;
}
.gray-color {
  @extend .colorbase;
  color: #ccc;
}
</style>
